import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { destroy } from 'redux-form';

import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions, selectors as operationSelectors } from 'ducks/uiOperations';
import { selectors as customerSelectors, actions as customerActions } from 'ducks/customer';
import { actions as formActions, selectors as formSelectors } from 'ducks/form';
import CustomerMaintenance from './CustomerMaintenance';
import { IApplicationState } from 'ducks/reducers';

const mapStateToProps = (state: IApplicationState) => ({
  operationMode: operationSelectors.operationMode(state),
  selectedTab: uiSelectors.selectedTab(state),
  selectedCustomer: customerSelectors.selected(state),
  isBrowseLookUpOpen: uiSelectors.isBrowseLookUpOpen(state),
  isMenuOptionOpen: uiSelectors.isMenuOptionOpen(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  selectedForm: formSelectors.selected(state),
  customerLoading: customerSelectors.isFetched(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    toggleCustomerLookUp: uiActions.toggleCustomerLookUp,
    toggleBrowseLookUp: uiActions.toggleBrowseLookUp,
    changeOperationMode: operationActions.changeOperationMode,
    changeSelectedTab: uiActions.changeSelectedTab,
    getFormSchema: formActions.search,
    changeSelectedForm: formActions.setSelected,
    toggleMenuOption: uiActions.toggleMenuOption,
    closeMenu: uiActions.closeMainMenu,
    resetSearchLookupDrawer: customerActions.reset,
    destoryForm: () => destroy('CustomerForm'),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CustomerMaintenance);
